import { app, Component } from 'apprun';
import slider from './property-slider';
import map from './osm-property';
import { __ } from './Txlat';
import { getId, getPropertyLink, build_share_links, $, $attr, $html, add_meta, add_link, set_title, setDetailLanguageLink, getPropertyIcon } from './utility';
import { getPropertyMetaDescription, getPropertyByID, getPropertyFeatures, getPropertyDetailStatusPrice } from './model/property';
import PropertyDetail from './template/property-detail-template';
import InquiryForm from './inquiry-form';
import InqueryTitle from './agent-inquiry-title';
import { agent } from './api';
export const getAgentByIDAndPersonID = agent.getAgentByIDAndPersonID;

function getPropertyDetailSlidersHtml(photos) {
  let photosHtml = '';
  for (let i = 0; i < photos?.length; i++) {
    photosHtml += `<div data-thumb="${photos[i].path}"><a rel="gallery-1" data-slider-no="${i}"
        class="houzez-trigger-popup-slider-js swipebox">
        <img class="img-fluid" style="object-fit: cover;object-position:0 0; max-width: 100%; cursor: pointer;" src="${photos[i].path}" alt="" title=""></a></div>`;
  }
  return photosHtml;
}
class propertyDetail extends Component {
  state = {
    propertyId: null
  };

  view = (state) => {
    $attr('.houzez-icon.icon-share', 'title', __('Share'));
    $attr('.houzez-icon.icon-print-text', 'title', __('Print'));

    $('.houzez-icon.icon-picture-sun').parentElement.setAttribute('title', __('Picture'));
    $('.houzez-icon.icon-maps').parentElement.setAttribute('title', __('Map'));

    if (state && state.property) {
      build_share_links(state.property);
    }

    return (
      <PropertyDetail property={state.property} features={state.features} />
    );
  };

  update = {
    '#': async (state) => {
      state.id = getId();
      state.property = await getPropertyByID(state.id);
      if (!state.property) {
        location.href = '/not-found';
        return;
      }
      const property_url = getPropertyLink(state.property);
      if (window.location.pathname !== encodeURI(property_url)) {
        window.location.href = property_url;
        return;
      }

      state.photos = state.property.propPhotos ? state.property.propPhotos.map(p => ({ 'path': p })) : [{ path: '/images/missing-prop.png' }];
      state.features = getPropertyFeatures(state.property);

      // state.agent = await getPropertyAgentByID(state.property.agent_id);
      const agent1 = { id: state.property.agent_person_id, alaia_id: state.property.agent_id, photo_path: state.property.agent_photo, name: state.property.agent_name, address: state.property.agent_address, city: state.property.agent_city, province: state.property.agent_province, postal_code: state.property.agent_postal_code, phone: state.property.agent_phone, email: state.property.agent_email, officeName: state.property.agent_office_name, title: state.property.agent_title, title_FR: state.property.agent_title_FR, isCommercailAgent: false };
      const agent2 = { id: state.property.agent2_person_id, alaia_id: state.property.agent2_id, photo_path: state.property.agent2_photo, name: state.property.agent2_name, address: state.property.agent2_address, city: state.property.agent2_city, province: state.property.agent2_province, postal_code: state.property.agent2_postal_code, phone: state.property.agent2_phone, email: state.property.agent2_email, officeName: state.property.agent_office_name, title: state.property.agent2_title, title_FR: state.property.agent2_title_FR, isCommercailAgent: false };

      if ((agent1?.id || agent1?.alaia_id) && agent1?.name) {
        const pid = await getAgentByIDAndPersonID(agent1.alaia_id ?? -1, agent1.id ?? -1);
        if (pid.length > 0) {
          agent1.isCommercailAgent = true;
          agent1.id = pid[0].id;
          agent1.alaia_id = pid[0].alaia_id;
        } else {
          agent1.isCommercailAgent = false;
        }
      }

      if ((agent2?.id || agent2?.alaia_id) && agent2?.name) {
        const pid2 = await getAgentByIDAndPersonID(agent2.alaia_id ?? -1, agent2.id ?? -1);
        if (pid2.length > 0) {
          agent2.isCommercailAgent = true;
          agent2.id = pid2[0].id;
          agent2.alaia_id = pid2[0].alaia_id;
        } else {
          agent2.isCommercailAgent = false;
        }
      }

      const { address, city, province, postal_code, lease_price } = state.property;
      const title = `${address} ${city} ${province} ${postal_code} - ${(lease_price > 0) ? __('For Lease') : __('For Sale')}`;
      set_title(`${title} | ${__('Royal LePage Commercial')}`);
      add_meta(getPropertyMetaDescription(state.property));
      add_link('canonical', property_url);
      add_link('alternate', property_url, 'en');
      add_link('alternate', getPropertyLink(state.property, 'fr'), 'fr');
      const emailSubject = `${__('Inquiry regarding - ')}MLS ${state.property.mls_id} - ${state.property.address}`;
      app.run('/setInqueryComponentState', { inqueryTitle: <InqueryTitle agent1={agent1} agent2={agent2} />, email: agent1.email, email2: agent2.email, agent1_name: agent1.name, agent2_name: agent2.name, inquiryType: 'PropertyInquiry', sub: emailSubject, property: state.property, form_type: 'Property' });
      return state;
    }
  };

  rendered = ({ property, photos }) => {
    if (!property || !photos) { return; }
    const propertyDetailSlidersHtml = getPropertyDetailSlidersHtml(photos);
    $html('#property-slider-js', propertyDetailSlidersHtml);

    slider();
    const statusPrice = getPropertyDetailStatusPrice(property);

    const houzez_single_property_map = {
      // window['houzez_single_property_map'] = {
      'title': property.address,
      'url': '',
      'price': statusPrice.price,
      'property_id': property.mls_id,
      'pricePin': statusPrice.price,
      'address': property.address,
      'property_type': property.property_type && property.property_type.length ? __(property.property_type[0].toUpperCase()) : '',
      'lat': property.latitude,
      'lng': property.longitude,
      'term_id': 0,
      'marker': getPropertyIcon(property.property_type),
      'retinaMarker': getPropertyIcon(property.property_type),
      'thumbnail': property.property_photo
    };

    map(houzez_single_property_map);

    setDetailLanguageLink(property, getPropertyLink);
  };
}

new propertyDetail().start('.col-lg-8.col-md-12.bt-content-wrap');
new InquiryForm({ message: __('I would like more information on this property, please contact me.') }).start('.sidebar-wrap');
new InquiryForm({ isPopup: true, message: __('I would like more information on this property, please contact me.') }).start('.mobile-property-form .modal-body');
